'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isFunction(value) {
    return typeof value === 'function';
}

exports.isFunction = isFunction;
